if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('alturex-cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('alturex-cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    // ---- KLAVIYO TRACK "Added to Cart" ----
    window._learnq = window._learnq || [];

    var itemInfo = {
      ProductName: response.title,
      ProductID: response.id,
      SKU: response.sku,
      Categories: response.product_type,
      ImageURL: response.image || (response.featured_image && response.featured_image.url),
      URL: window.location.href,
      Brand: response.vendor,
      Price: response.price ? response.price / 100 : 0,
      CompareAtPrice: response.compare_at_price ? response.compare_at_price / 100 : null,
      Quantity: response.quantity || 1
    };

    window._learnq.push(['track', 'Added to Cart', itemInfo]);
    // ---- /KLAVIYO ----

    // --- LÓGICA DEL TEMA ORIGINAL ---
    if (response.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        errors: response.errors || response.description,
        message: response.message,
      });

      this.handleErrorMessage(response.description);

      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      if (!soldOutMessage) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span').classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
      this.error = true;
      return;
    } else if (!this.cart) {
      // si no hay drawer/cart ajax, redirige al carrito normal
      window.location = window.routes.cart_url;
      return;
    }

    // ALTUREX: si el add viene desde el quick-add modal de colección, lo cerramos
    // antes de abrir el drawer para que no queden modal + drawer superpuestos.
    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal && typeof quickAddModal.hide === 'function') quickAddModal.hide(true);

    // si todo salió bien y sí hay drawer (mini-carrito)
    this.cart.renderContents(response);

    this.submitButton.classList.remove('loading');
    this.submitButton.removeAttribute('aria-disabled');
    // --- FIN LÓGICA DEL TEMA ORIGINAL ---
  })
  .catch((e) => {
    console.error(e);
  })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
